import api from './api';

const unidadesResidencialesService = {
  // Obtener todas las unidades residenciales
  getUnidadesResidenciales: async () => {
    try {
      const response = await api.get('/api/UnidadesResidenciales');
      return response.data;
    } catch (error) {
      console.error('Error al obtener unidades residenciales:', error);
      throw error;
    }
  },

  // Obtener una unidad residencial por ID
  getUnidadResidencialById: async (id) => {
    try {
      const response = await api.get(`/api/UnidadesResidenciales/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener unidad residencial con ID ${id}:`, error);
      throw error;
    }
  },

  // Obtener unidades residenciales por company patner
  getUnidadesByCompanyPatner: async (companyPatnerId) => {
    try {
      // Normalizar el GUID a mayúsculas para compatibilidad con la BD
      const normalizedId = companyPatnerId.toUpperCase();
      const response = await api.get(`/api/UnidadesResidenciales/by-company-patner/${normalizedId}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener unidades del company patner ${companyPatnerId}:`, error);
      throw error;
    }
  },

  // Obtener unidades residenciales por ciudad
  getUnidadesByCiudad: async (ciudad) => {
    try {
      const response = await api.get(`/api/UnidadesResidenciales/by-ciudad/${encodeURIComponent(ciudad)}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener unidades de la ciudad ${ciudad}:`, error);
      throw error;
    }
  },

  // Crear una nueva unidad residencial
  createUnidadResidencial: async (unidadData) => {
    try {
      // Validaciones
      if (!unidadData.name || unidadData.name.trim() === '') {
        throw new Error('El nombre de la unidad es requerido');
      }

      if (!unidadData.ciudad || unidadData.ciudad.trim() === '') {
        throw new Error('La ciudad es requerida');
      }

      if (!unidadData.email_unidad || unidadData.email_unidad.trim() === '') {
        throw new Error('El email de la unidad es requerido');
      }

      // Validar formato de email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(unidadData.email_unidad)) {
        throw new Error('El formato del email no es válido');
      }

      if (unidadData.number_homes !== undefined) {
        const homes = parseInt(unidadData.number_homes);
        if (isNaN(homes) || homes < 0) {
          throw new Error('El número de viviendas debe ser un número positivo');
        }
      }

      if (unidadData.businness_unidad !== undefined) {
        const percentage = parseFloat(unidadData.businness_unidad);
        if (isNaN(percentage) || percentage < 0 || percentage > 100) {
          throw new Error('El porcentaje de negocio debe estar entre 0 y 100');
        }
      }

      if (!unidadData.company_patner_id) {
        throw new Error('El ID del company patner es requerido');
      }

      const response = await api.post('/api/UnidadesResidenciales', unidadData);
      return response.data;
    } catch (error) {
      console.error('Error al crear unidad residencial:', error);
      throw error;
    }
  },

  // Actualizar una unidad residencial existente
  updateUnidadResidencial: async (id, unidadData) => {
    try {
      // Validaciones
      if (unidadData.name !== undefined && unidadData.name.trim() === '') {
        throw new Error('El nombre de la unidad no puede estar vacío');
      }

      if (unidadData.ciudad !== undefined && unidadData.ciudad.trim() === '') {
        throw new Error('La ciudad no puede estar vacía');
      }

      if (unidadData.email_unidad !== undefined) {
        if (unidadData.email_unidad.trim() === '') {
          throw new Error('El email no puede estar vacío');
        }
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(unidadData.email_unidad)) {
          throw new Error('El formato del email no es válido');
        }
      }

      if (unidadData.number_homes !== undefined) {
        const homes = parseInt(unidadData.number_homes);
        if (isNaN(homes) || homes < 0) {
          throw new Error('El número de viviendas debe ser un número positivo');
        }
      }

      if (unidadData.businness_unidad !== undefined) {
        const percentage = parseFloat(unidadData.businness_unidad);
        if (isNaN(percentage) || percentage < 0 || percentage > 100) {
          throw new Error('El porcentaje de negocio debe estar entre 0 y 100');
        }
      }

      const response = await api.put(`/api/UnidadesResidenciales/${id}`, unidadData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar unidad residencial con ID ${id}:`, error);
      throw error;
    }
  },

  // Eliminar una unidad residencial
  deleteUnidadResidencial: async (id) => {
    try {
      const response = await api.delete(`/api/UnidadesResidenciales/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar unidad residencial con ID ${id}:`, error);
      throw error;
    }
  }
};

export default unidadesResidencialesService;
